export default "__VITE_ASSET__ipGQ7Eua__"